(() => {
  if (window.B2HDrawer) return;

  const parseTime = (value) => {
    const normalized = String(value).trim();
    if (normalized.endsWith('ms')) return Number.parseFloat(normalized) || 0;
    if (normalized.endsWith('s')) return (Number.parseFloat(normalized) || 0) * 1000;
    return 0;
  };

  const getMotionTime = (element) => {
    const style = window.getComputedStyle(element);
    const durations = style.transitionDuration.split(',').map(parseTime);
    const delays = style.transitionDelay.split(',').map(parseTime);
    const count = Math.max(durations.length, delays.length);

    return Array.from({ length: count }, (_, index) => {
      const duration = durations[index % durations.length] || 0;
      const delay = delays[index % delays.length] || 0;
      return duration + delay;
    }).reduce((maximum, value) => Math.max(maximum, value), 0);
  };

  const setState = (element, state) => {
    if (element) element.dataset.b2hDrawerState = state;
  };

  const afterMotion = (element, callback, { property = 'transform' } = {}) => {
    if (!element || typeof callback !== 'function') return () => {};

    let settled = false;
    let timeoutId;

    const cleanup = () => {
      element.removeEventListener('transitionend', onTransitionEnd);
      window.clearTimeout(timeoutId);
    };

    const finish = () => {
      if (settled) return;
      settled = true;
      cleanup();
      callback();
    };

    const onTransitionEnd = (event) => {
      if (event.target !== element || event.pseudoElement || event.propertyName !== property) return;
      finish();
    };

    element.addEventListener('transitionend', onTransitionEnd);
    timeoutId = window.setTimeout(finish, getMotionTime(element) + 34);

    return () => {
      if (settled) return;
      settled = true;
      cleanup();
    };
  };

  window.B2HDrawer = Object.freeze({ afterMotion, setState });
})();
